import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { trackEvent } from './analytics'

export default function useSettingsBack(actionContext, priorRoute) {
  const dispatch = useDispatch()
  const history = useHistory()

  return () => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_item_click',
      module: 'Settings',
      object: 'BackButton',
      action: 'Click',
      actionContext,
      actionContextValue: 'BackButton',
    })

    window.scrollTo(0, 0)
    history.replace(priorRoute)
  }
}
